/**
 * Platform detection utility.
 *
 * `isNative()` returns true when running inside the Capacitor iOS or Android
 * shell. Used as a guard before calling native plugins so the same React
 * build can run on web (washpros.io), iOS, and Android without conditionals
 * scattered everywhere.
 */
import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform(); // 'web' | 'ios' | 'android'
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';
